import { render, staticRenderFns } from "./OverviewService.vue?vue&type=template&id=24d5f017&scoped=true"
import script from "./OverviewService.vue?vue&type=script&lang=js"
export * from "./OverviewService.vue?vue&type=script&lang=js"
import style0 from "./OverviewService.vue?vue&type=style&index=0&id=24d5f017&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d5f017",
  null
  
)

export default component.exports